import {Badge, MantineSize, Text, TextProps} from "@mantine/core";
import {FC} from "react";

const NewBadge: FC<{size?: MantineSize, plainMode?: boolean} & TextProps> = ({size = 'lg', plainMode, ...others}: any) => {
    return plainMode ? <Text fw={'normal'} c={'yellow'} size={size} {...others}>NEW</Text> : <Badge color="yellow" size={size} radius="xs" px={6}>
        <Text fw={'bold'} {...others}>NEW</Text>
    </Badge>
}

export default NewBadge
